<form [formGroup]="retailerSearchFormGroup"  id="step-retailer-selection" class="h-full">
  <div class="flex flex-1 flex-col rounded-card h-full overflow-visible pb-6">
    <div class="row">
      <div class="flex flex-col col-12">
        <h2 data-testid="select-retailer-title" class="pb-2">{{ 'WARRANTY_ACTIVATION.RETAILER_SELECTION' | translate }}</h2>
        <label data-testid="select-retailer-label" class="block text-sm mb-4" for="retailerId">{{ 'WARRANTY_ACTIVATION.SEARCH_RETAILER' | translate }}:</label>
      </div>
      <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6">
        <app-custom-dropdown
          data-testid="retailer"
          [placeholder]="'WARRANTY_ACTIVATION.SELECT_RETAILER_PLACEHOLDER' | translate"
          optionLabel="text"
          optionValue="id"
          [isMultiselect]="false"
          [showSelectionChips]="true"
          [showClear]="true"
          [searchMode]="'remote'"
          [pageSize]="comboData.rowsPerPageOption || 5"
          [totalCount]="comboData.totalRecords"
          [totalPages]="getComboTotalPages()"
          [options]="comboData.list"
          formControlName="retailerId"
          (onLazyLoad)="onLazyLoadComboData($event)">
        </app-custom-dropdown>
      </div>
      <div class="field-wr flex flex-col col-12 col-sm-12 col-md-2">
        <button data-testid="select-retailer-btn" class="btn primary-btn" [disabled]="retailerSearchFormGroup.invalid" (click)="onSaveStepData()">{{ 'WARRANTY_ACTIVATION.BTN_NEXT_STEP' | translate }}</button>
      </div>
    </div>
  </div>
</form>
